<script setup lang="ts">
import BrandLockup from "./BrandLockup.vue";
import ClassASvg from "./ClassASvg.vue";
</script>

<template>
  <div class="min-h-screen flex flex-col bg-gray-100">
    <!-- Centered rather than top-aligned so the short handshake page doesn't leave a gulf
         above the footer; the long marketing page overflows it and is unaffected. -->
    <section class="grow flex items-center py-12 sm:py-16 px-4 sm:px-6">
      <div class="mx-auto max-w-5xl w-full">
        <BrandLockup class="mb-10 sm:mb-14" />
        <slot />
      </div>
    </section>

    <slot name="wide" />

    <!-- The yellow band closing on the wordmark is the house signature; see the OPA pages. -->
    <div class="bg-primary-500 h-40 sm:h-56 shrink-0">
      <UContainer class="flex justify-center items-end size-full mx-auto">
        <ClassASvg class="text-brand-500 w-full max-w-3xl" />
      </UContainer>
    </div>
  </div>
</template>
